<template>
  <div class="py-4 container-fluid">
    <div class=" row">
      <div class="col-12 pb-0 card-header mb-0">
        <div class="google-map" ref="googleMap"></div>
        <template v-if="Boolean(this.google) && Boolean(this.map)">
          <slot
            :google="google"
            :map="map"
          />
        </template>
      </div>
      <div class="col-12">
        <rotas-table :rotas="rotas" :motoristas="motoristas" :map="map" :toggleRoute="toggleRoute" :alocarMotorista="setMotoristas" :reOrdenar="setOrdem" :salvarRotas="salvarUnico" />
      </div>
    </div>
  </div>
</template>
<style>
   .custom-marker {
      background-color: white;
      border-radius: 50%;
      padding: 10px;
      text-align: center;
      border: 2px solid black;
      width: 50px;
      height: 50px;
    }

    .custom-marker img {
      width: 100%;
      border-radius: 50%;
    }
</style>
<script>

import GoogleMapsApiLoader from 'google-maps-api-loader'

import { MarkerClusterer } from "@googlemaps/markerclusterer";

import { defineComponent, ref , toRaw  } from 'vue';

import RotasTable from "./components/RotasTempoReal.vue";

import ArgonButton from "@/components/ArgonButton.vue"; 

import fintailapi from "../api";

export default defineComponent({
  name: "tables",
  components: {
    RotasTable,
    ArgonButton
  },
  data() {
    return {
      map: null,
      google: null,
      rotas: [],
      motoristas:[],
      current_page:0,
      total_pages:0,
      id_motorista:[],
      marker_motoristas:[],
      intervalId: null // <- armazenar o ID do intervalo
    };
  },
  async mounted() {
    
    const googleMapApi = await GoogleMapsApiLoader({
      apiKey: process.env.VUE_APP_MAPS_APIKEY,
      v:'beta'
    })

    this.google = googleMapApi;
    this.initializeMap();

    this.intervalId = setInterval(() => {
      this.onIntervalTick();
    }, 10000);


  },
  methods: {

    onIntervalTick() {



        fintailapi
        .post(`/rotas/realtime`, {id_motorista:this.id_motorista})
        .then((response) => {

          

          for (const id_operador in response.data.cordenadas) {
              
              const cordenada = response.data.cordenadas[id_operador];
    
              const idOperador = cordenada.id_operador;

              const lat = cordenada[0].coordenada.coordinates[0]; // Latitude
              const lng = cordenada[0].coordenada.coordinates[1]; // Longitude
            
                      
              if (this.marker_motoristas[idOperador]) {

                this.marker_motoristas[idOperador].ponto.setPosition({ lat, lng });

                const path = cordenada.map(p => ({
                  lat: p.coordenada.coordinates[0], // latitude
                  lng: p.coordenada.coordinates[1]  // longitude
                }));
     
                this.marker_motoristas[idOperador].linha.setPath(path);
                

              } else {

                this.marker_motoristas[idOperador]= { linha: null, ponto: null }

                const path = cordenada.map(p => ({
                  lat: p.coordenada.coordinates[0], // latitude
                  lng: p.coordenada.coordinates[1]  // longitude
                }));

                const linha = new this.google.maps.Polyline({
                  path: path,
                  geodesic: true,
                  strokeColor: '#FF0000',
                  strokeOpacity: 0,
                  strokeWeight: 1,
                  icons: [{
                    icon: {
                      path: google.maps.SymbolPath.BACKWARD_CLOSED_ARROW, // ou PATH customizado
                      strokeOpacity: 1,
                      strokeWeight: 2,
                      scale: 1
                    },
                    offset: '0',
                    repeat: '20px'
                  }],
                  map: this.map
                });

                this.marker_motoristas[idOperador].linha = linha

                const marker = new this.google.maps.Marker({
                  position: { lat, lng },
                  map: this.map,
                  title: `Motorista ${idOperador}`,
                  icon: 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png'
                });

                this.marker_motoristas[idOperador].ponto = marker;

              }

          }
          

        })
        .catch((error) => {
          console.log(error)
        })
        

    },

    toggleRoute(rota) {

      rota.visible = !rota.visible;


      if(rota.visible)rota._polyline.setMap(this.map);
      else rota._polyline.setMap(null);

    },
    initializeMap() {

      console.log("MAP")
      const mapContainer = this.$refs.googleMap

      this.map = new this.google.maps.Map(
        mapContainer, {  
            clickableIcons: false,
            streetViewControl: false,
            panControlOptions: true,
            gestureHandling: "cooperative",
            mapTypeControl: true,
            styles: [
                        {
                            "featureType": "administrative",
                            "elementType": "labels",
                            "stylers": [{ "visibility": "off" }]
                        },
                        {
                            "featureType": "poi",
                            "stylers": [{ "visibility": "off" }]
                        },
                        {
                            "featureType": "road",
                            "elementType": "labels",
                            "stylers": [{ "visibility": "on" }]
                        },
                        {
                            "featureType": "transit",
                            "stylers": [{ "visibility": "off" }]
                        },
                        {
                            "featureType": "water",
                            "elementType": "labels",
                            "stylers": [{ "visibility": "off" }]
                        }
                    ],
                
            zoomControlOptions: {
              style: "SMALL"
            },

            zoom: 13,
            minZoom: 8,
            maxZoom: 20,
            center: { lat: -22.2941067, lng: -48.5642125 }
        }
      )


      this.map.addListener('zoom_changed', () => {

      });

      //INICIALIZA AS ROTAS
      this.getRotas()


    },
    getRota(id) {

      fintailapi
      .get(`/rotas/${id}`)
      .then((response) => {

          const colors = ['#FF0000', '#0000FF', '#00FF00', '#FFA500', '#800080', '#00FFFF']; // Exemplo de cores

          this.current_page = 0;

          let rota = response.data;
          this.total_pages = response.data.count / 10

          const { Polyline, Marker } = this.google.maps;

          const decodedPoints = rota.rota.Caminho.flatMap(segment => [
            { lat: segment.startPoint.coordinates[1], lng: segment.startPoint.coordinates[0] },
            { lat: segment.endPoint.coordinates[1], lng: segment.endPoint.coordinates[0] }
          ]);

          let routePath = new Polyline({
            path: decodedPoints,
            geodesic: true,
            strokeColor: colors[0],
            strokeOpacity: 0.4,
            strokeWeight: 8,
          });

          routePath.setMap(this.map);

          for(let pedido of rota.rota.Pedidos){

              const local = {
                  id: pedido.id_pedido,
                  position: { lat: parseFloat(pedido.latitude), lng:  parseFloat(pedido.longitude) }
              };

              new Marker({
                position: local.position,
                marker: local,
                map: this.map,
                icon: 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png'
              });

          }

          new Marker({
            position: { lat: rota.rota.Operacao.latitude, lng:  rota.rota.Operacao.longitude},
            map:  this.map,
            title: "Centro",
            icon: 'http://maps.google.com/mapfiles/ms/icons/red-dot.png' // Ícone do marcador
          });


      })
      .catch((error) => {

        //this.isOpenRef = true;

      })

    },
    getRotas() {

        fintailapi
        .get(`/rotas`)
        .then(async(response) => {


            this.getMotoristas();

            this.current_page = 0;

            let local_rotas = response.data;

            for(let rota of local_rotas){

              rota.Pedidos.sort((a, b) => a.ordem - b.ordem);

            }


            local_rotas = local_rotas.filter((p) => p.status_entrega === 1);

            this.rotas = local_rotas;

            this.total_pages = response.data.count / 10


            const { Polyline, Marker } = this.google.maps;
          
            const colors = [
              '#FF0000', '#0000FF', '#00FF00', '#FFA500', '#800080', '#00FFFF',
              '#FFD700', '#FF69B4', '#8A2BE2', '#FF4500', '#7FFF00', '#DC143C',
              '#00BFFF', '#9932CC', '#FF1493', '#FF6347', '#2E8B57', '#FF7F50',
              '#6A5ACD', '#20B2AA', '#B22222', '#32CD32', '#BA55D3', '#4682B4',
              '#808000', '#DAA520', '#B0E0E6', '#A52A2A', '#8B4513', '#5F9EA0',
              '#D2691E', '#FF00FF', '#F08080', '#C71585', '#000080', '#008080',
              '#9ACD32', '#FFDAB9', '#708090', '#DDA0DD', '#EEE8AA', '#AFEEEE'
            ];
            
            let key = 0;

            for(let rota of this.rotas){

                //SETA A COR DA ROTA
                this.rotas[key].color = colors[key % colors.length]


                const decodedPoints = rota.Caminho.flatMap(segment => [
                    { lat: segment.startPoint.coordinates[1], lng: segment.startPoint.coordinates[0] },
                    { lat: segment.endPoint.coordinates[1], lng: segment.endPoint.coordinates[0] }
                ]);

                //CALCULA A DISTANCIA TOTAL DO PATH
                this.rotas[key].distance = (rota.Caminho.reduce((acc, item) => acc + item.distance, 0)).toFixed(2);

                //CRIA O DESENHO DA LINHA DO TRAJETO
                let routePath = new Polyline({
                    path: decodedPoints,
                    geodesic: true,
                    strokeColor: colors[key % colors.length],
                    strokeOpacity: 0.6,
                    strokeWeight: 4
                });
                routePath.setMap(this.map);
                

                let all_markers = []
                let sequencia = 0;

                let ce = new Marker({
                    position: { lat: rota.Operacao.latitude, lng: rota.Operacao.longitude },
                    title: "Centro",
                    icon: 'http://maps.google.com/mapfiles/ms/icons/red-dot.png'
                })
                all_markers.push(ce)

                //PEGA O MOTORISTA QUE ESTA NA ROTA
                if (!this.id_motorista.includes(rota.operador_id)) {
                  this.id_motorista.push(rota.operador_id);
                }
  
                for(let pedido of rota.Pedidos){

                    const local = {
                        id: pedido.id_pedido,
                        position: { lat: parseFloat(pedido.latitude), lng:  parseFloat(pedido.longitude) }
                    };


                    let marker =  new Marker({
                      
                      title: pedido.numero_pedido,

                      position: local.position,
                      // adjust zIndex to be above other markers
                      zIndex: Number(this.google.maps.Marker.MAX_ZINDEX) + pedido.ordem,
                      icon: {
                          url: 'data:image/svg+xml;utf-8,' + encodeURIComponent(`
                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 1024 1024">
                        <path d="M512 85.333333c-164.949333 0-298.666667 133.738667-298.666667 298.666667
                                0 164.949333 298.666667 554.666667 298.666667 554.666667s298.666667-389.717333
                                298.666667-554.666667c0-164.928-133.717333-298.666667-298.666667-298.666667z
                                m0 448a149.333333 149.333333 0 1 1 0-298.666666 149.333333 149.333333 0 0 1 0 298.666666z"
                              fill="${colors[key % colors.length]}" />
                        <text x="512" y="420" text-anchor="middle" alignment-baseline="middle"
                              font-size="320"  fill="#ffffff">${pedido.ordem}</text>
                      </svg>
                          `),


                      }
                    })

                    all_markers.push(marker);

                  

                    

                    sequencia++
                }



                ce = new Marker({
                    position: { lat: rota.Operacao.latitude, lng: rota.Operacao.longitude },
                    title: "Centro",
                    icon: 'http://maps.google.com/mapfiles/ms/icons/red-dot.png'
                })
                all_markers.push(ce)

                
                //
                const cluster =  new MarkerClusterer({ map: this.map, markers: all_markers });

                rota._polyline = routePath;
                rota._cluster  = cluster;
                rota._markers  = all_markers;
                rota.visible   = true;


                key++

            }
         
            //const newLocation = { lat: parseFloat(this.rotas[0].latitude), lng: parseFloat(this.pedidos[0].longitude)  }; // Rio de Janeiro
            //this.map.setCenter(newLocation); // Define o novo centro


        })
        .catch((error) => {
          console.log(error)
          //this.isOpenRef = true;

        })

    },
    getMotoristas() {

          fintailapi
          .get(`/transportadores`)
          .then(async(response) => {

              this.motoristas = response.data.rows;

          })
          .catch((error) => {

            console.log(error)
            //this.isOpenRef = true;

          })

    },

    setMotoristas(id_veiculo, id_rota, id_transportador){

      fintailapi
      .post(`/transportadores/alocar/${id_veiculo}/${id_rota}/${id_transportador}`,{})
      .then((response) => {
          this.getRotas()
      });

    },

    setOrdem(pedido){

      fintailapi
      .patch(`/pedidos/reordenar/${pedido.id_pedido}`, pedido)
      .then((response) => {
          //this.getRotas()

                fintailapi
                .get(`/rotas/processar/${pedido.id_rota}`)
                .then((response) => {
                    
                });

      });

    },
    salvarUnico(rota){
     

      let update = { fixa: rota.fixa }

      fintailapi
      .put(`/rotas/${rota.id}`, update)
      .then((response) => {

        //this.getRotas()

      });

    }
    
  },
 
  created() {

  },
  beforeUnmount() {
    // Limpa o timer ao destruir o componente
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  },
});


</script>
